<template lang="html">
  <div id="cart-page" class="d-flex account-page">
    <div class="container main-box">

      <div class="row mb-3">
        <div class="col-lg px-2 col-page-title">
          <h1 class="page-title">Mi carrito</h1>
        </div>

        <div class="col-lg col-steps">
          <div class="row">
            <div class="col-md-4 col-step active">
              <div class="col number">1</div>
              <div class="col text">Revisa los productos de tu carrito</div>
            </div>

            <div class="col-md-4 col-step" v-bind:class="{ 'active' : $route.params.step == 'envio' }">
              <div class="col number">2</div>
              <div class="col text">Valida los datos y selecciona la forma de entrega</div>
            </div>

            <div class="col-md-4 col-step" v-bind:class="{ 'active' : $route.params.step == 'pago' }">
              <div class="col number">3</div>
              <div class="col text">Selecciona forma de pago y finaliza tu compra</div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg px-2 col-menu">
          <div class="white-box">
            <div class="box-menu py-2">
              <!-- <p class="item">
                <router-link class="btn-menu" to="/mis-favoritos"><i class="fas fa-heart"></i> Mis favoritos</router-link>
              </p> -->
              <p class="item">
                <router-link class="btn-menu" to="/cart"><i class="fas fa-shopping-cart"></i> Mi carrito</router-link>
              </p>
              <p class="item" v-if="$root.logged">
                <router-link class="btn-menu" to="/usuario"><i class="far fa-edit"></i> Mis datos</router-link>
              </p>
              <p class="item" v-if="$root.logged">
                <router-link class="btn-menu" to="/usuario/contrasena"><i class="fas fa-lock"></i> Mi contraseña</router-link>
              </p>
              <p class="item" v-if="$root.logged">
                  <router-link class="btn-menu" to="/usuario/historial-compras"><i class="fas fa-clipboard-list"></i> Historial de compras</router-link>
              </p>
              <p class="item" v-if="$root.logged">
                  <a class="btn-menu" v-on:click="logout()" style="cursor: pointer;"><i class="fas fa-sign-out-alt"></i> Cerrar sesión</a>
                </p>
            </div>
          </div>
        </div>

        <div class="col-lg px-2 col-cart-data">

          <!-- <div class="white-box"> -->
          <b-form class="white-box" @submit.prevent="">

            <!-- Paso 1 (Lista de productos agregados a carrito) -->
            <div class="col-12 pt-3 product-list-table" v-if="$route.params.step !== 'envio' && $route.params.step !== 'pago'">
              <div class="col-12 px-0">
                <h5>Productos agregados al carrito</h5>

                <h6 class="mt-4 pb-4 f-w-400 text-warning" v-if="!form.products.length"><i class="fas fa-shopping-basket"></i> Ningun producto ha sido agregado al carrito</h6>
              </div>

              <div class="row row-products" v-for="(product, index) in form.products">
                <div class="col col-image">
                  <img :src="product.imageUrl">
                </div>

                <div class="col col-info">
                  <h5 class="txt-name">
                    <router-link target="_blank" :to="'/producto/'+product.id">{{ product.name }}</router-link>
                  </h5>

                  <div class="row mx-0 align-items-center">
                    <div class="d-flex">
                      <h6 class="txt-sm text-muted">SKU: {{ product.sku }}</h6>
                    </div>
                    <div class="d-flex">
                      <div class="box-color-opt opt-sm">
                        <!-- <a class="color" title="Color x" v-bind:style="{ backgroundColor: '#e63003' }">{{ product.color }}</a> -->
                        <a class="color" :title="product.color">{{ product.color }}</a>
                        <a class="color" :title="product.size">{{ product.size }}</a>
                      </div>
                    </div>
                  </div>
                  <hr class="mt-0 mb-1" />

                  <router-link class="link-sm text-muted" target="_blank" :to="'/producto/'+product.id">Ver producto</router-link> <span class="mx-2">|</span> <a class="link-sm text-danger" @click="removeCart(index)"><i class="far fa-trash-alt"></i> Quitar</a>
                </div>

                <div class="col col-price">
                  <p>$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} MXN<br>{{ product.sales_items_per_unit }} {{ product.sales_unit }}</p>
                </div>
                <div class="col col-num">
                  <b-form-input v-model="product.quantity" type="number" min="1" :max="product.stock" placeholder="1" @change="checkStock(index)"/>
                </div>
              </div>
            </div>
            <!-- paso 1, Fin -->

            <!-- Paso 2 (Envio, Datos del usuario y datos de envío) -->
            <div class="col-12 py-4 px-4 user-data" v-if="$route.params.step == 'envio'">
                <h6><b>Datos de personales</b></h6>
                <hr class="c-hr" />

                <p class="note-s1 txt-blue f-w-600">
                  Crea una cuenta en donde podrás guardar tus direcciones y tarjetas para comprar más fácil y rápido, además, podrás crear listas de favoritos, recomprar productos y dar seguimiento a tus órdenes activas.
                </p>
                <hr class="c-hr" />

                <div class="custom-input _p">
                    <label class="col-form-label pt-0">Nombre:</label>
                    <p class="txt-simple" v-if="$root.logged">{{ form.user.name }}</p>
                    <b-form-input id="user-name" v-else type="text" v-model="form.user.name" size="sm" required placeholder="Nombre" />
                </div>

                <div class="custom-input _p">
                    <label class="col-form-label pt-0">Apellidos:</label>
                    <p class="txt-simple" v-if="$root.logged" v-text="form.user.lastname"></p>
                    <b-form-input id="user-lastname" v-else type="text" v-model="form.user.lastname" size="sm" required placeholder="Apellidos" />
                </div>

                <div class="custom-input _p">
                    <label class="col-form-label pt-0">Correo electrónico:</label>
                    <p class="txt-simple" v-if="$root.logged" v-text="form.user.email"></p>
                    <b-form-input id="user-email" v-else type="text" v-model="form.user.email" size="sm" required placeholder="Correo electrónico" />
                </div>

                <div class="custom-input _p">
                    <label class="col-form-label pt-0">Teléfono:</label>
                    <b-form-input id="user-phone" type="text" v-model="form.user.phone" size="sm" required placeholder="Teléfono" maxlength="10" min="10"/>
                </div>

                <p class="note-s1 f-w-500 w-email" style="color: #343333;">
                  Recibirás un correo recordándote tu nombre de usuario y una contraseña segura para acceder posteriormente.
                </p>


                <h6 class="mt-5"><b>Información de envío</b></h6>
                <hr class="c-hr" />

                <div class="row mx-0 no-gutters">
                    <div class="col-md-12">
                        <b-form-group class="custom-input" label="Tipo de entrega:" label-for="i-entrega">
                            <v-select v-model="form.shippingMethod" :options="['Enviar a domicilio', 'Recoger en tienda']" placeholder="Tipo de entrega"/>
                        </b-form-group>
                        <p v-if="form.shippingMethod == 'Enviar a domicilio'" style="text-align: center;color: #a82d39;">El horario de entregas a domicilio es de lunes a sábado de 8:00 am a 5:00 pm<br>
                          La entrega de tus productos se hará en un lapso de 2 a 3 días hábiles posteriores a tu compra, estos tiempos pueden variar, en caso muy específicos, por ejemplo; en pedidos especiales, en los casos que se requiera cortes de madera, alto volumen de productos, etc.
                          <br><br></p>
                          <p v-if="form.shippingMethod == 'Recoger en tienda'" style="text-align: center;color: #a82d39;">Su pedido se encontrará listo para recoger en la sucursal seleccionada en un periodo de 48 horas hábiles posteriores a su compra.<br>
                            Este tiempo puede variar en casos específicos como días festivos o fines de semana. En caso de que su pedido se encuentre listo para recoger antes del periodo mencionado, se le comunicará a través de los medios de contacto que registró.
                          <br><br></p>
                    </div>
                </div>

                <div v-if="form.shippingMethod == 'Enviar a domicilio'">
                    <div class="row mx-0 no-gutters">
                        <div class="col-md-7 col-lg-6">
                        <b-form-group class="custom-input" label="Calle:" label-for="i-calle">
                            <b-form-input id="i-calle" type="text" v-model="form.user.street" size="sm" placeholder="Calle donde vive" required/>
                        </b-form-group>
                        </div>

                        <div class="col-md pl-md-3">
                        <b-form-group class="custom-input" label="Numero exterior:" label-for="i-num">
                            <b-form-input id="i-num" type="text" v-model="form.user.num_ext" size="sm" required/>
                        </b-form-group>
                        </div>

                        <div class="col-md pl-md-3">
                        <b-form-group class="custom-input" label="Numero interior:" label-for="i-num">
                            <b-form-input id="i-num" type="text" v-model="form.user.num_int" size="sm"/>
                        </b-form-group>
                        </div>
                    </div>




                    <div class="row mx-0 no-gutters">
                        <div class="col-md-6 pr-md-3">
                        <b-form-group class="custom-input" label="Estado:" label-for="i-estado">
                            <v-select v-model="form.user.state_id" :options="states" label="name" index="id" @change="getTowns"/>
                        </b-form-group>
                        </div>

                        <div class="col-md-6">
                        <b-form-group class="custom-input" label="Ciudad:" label-for="i-ciudad">
                            <v-select v-model="form.user.town_id" :options="towns" label="name" index="id"/>
                        </b-form-group>
                        </div>
                    </div>

                    <div class="row mx-0 no-gutters">
                        <div class="col-md-8">
                            <!-- <b-form-group class="custom-input" label="Colonia:" label-for="i-colonia">
                                <b-form-input id="i-colonia" type="text" v-model="form.user.neighborhood" size="sm" required placeholder="Escriba su colonia" />
                            </b-form-group> -->
                            <b-form-group class="custom-input" label="Colonia:" label-for="i-ciudad" v-if="form.user.town_id == 2009">
                                <v-select v-model="form.user.neighborhood" :options="coloniastecate" label="id" index="id"/>
                            </b-form-group>
                            <b-form-group class="custom-input" label="Colonia:" label-for="i-ciudad" v-else-if="form.user.town_id == 1224">
                                <v-select v-model="form.user.neighborhood" :options="coloniasrosarito" label="id" index="id"/>
                            </b-form-group>
                            <b-form-group class="custom-input" label="Colonia:" label-for="i-ciudad" v-else-if="form.user.town_id == 2141">
                                <v-select v-model="form.user.neighborhood" :options="coloniastijuana" label="id" index="id"/>
                            </b-form-group>
                            <b-form-group class="custom-input" label="Colonia:" label-for="i-colonia" v-else>
                                <b-form-input id="i-colonia" type="text" v-model="form.user.neighborhood" size="sm" required placeholder="Escriba su colonia" />
                            </b-form-group>
                        </div>

                        <div class="col-md pl-md-3">
                        <b-form-group class="custom-input" label="Código postal:" label-for="i-cp">
                            <b-form-input id="i-cp" type="text" v-model="form.user.zipcode" size="sm" required placeholder="Escriba su código postal" />
                        </b-form-group>
                        </div>
                    </div>

                </div>
                <div v-if="form.shippingMethod == 'Recoger en tienda'">
                    <div class="row mx-0 no-gutters">
                        <div class="col-md-12 pr-md-3">
                          <b-form-group class="custom-input" label="Sucursal:" label-for="i-estado">
                              <v-select v-model="form.branchoffices_id" :options="branchofficesOpcs" label="name" index="id"/>
                          </b-form-group>
                        </div>
                    </div>
                </div>

                <b-form-checkbox id="checkbox-1" v-model="form.factura" name="checkbox-1">Solicitar Factura</b-form-checkbox>

                <div class="box-final-contact mt-4">
                  <h6 class="t">CONTACTO DE ENTREGA</h6>
                  <p style="text-align: center;">Si deseas que alguien mas reciba el pedido por ti agrega aqui su info.</p>
                  <div class="row">
                    <div class="col-lg-6">
                      <p>
                        <div class="custom-input _p">
                            <label class="col-form-label pt-0"><strong>NOMBRE</strong>:</label>
                            <b-form-input id="user-name" type="text" v-model="form.user.name_contact_delivery" size="sm"  />
                        </div>
                      </p>
                    </div>

                    <div class="col-lg-6 mt-2 mt-lg-0">
                      <p>
                        <div class="custom-input _p">
                            <label class="col-form-label pt-0"><strong>TELÉFONO</strong>:</label>
                            <b-form-input id="user-name" type="text" v-model="form.user.phone_contact_delivery" size="sm"  />
                        </div>
                      </p>
                    </div>
                  </div>
                </div>
                <br>
                <b-form-checkbox id="checkbox-terms" v-model="checkterms" name="checkbox-terms">He leido los <router-link to="/terminos-y-condiciones" target="_blank" style="color: black;text-decoration: underline;">Terminos y Condiciones</router-link> y <router-link to="/aviso-de-privacidad" target="_blank" style="color: black;text-decoration: underline;">Aviso de privacidad</router-link> de MADERAS Y FERRETERÍAS DURAN S. DE R.L. DE C.V.</b-form-checkbox>

                <div v-show="form.factura == true">
                    <h6 class="mt-4"><b>Datos de facturación</b></h6>
                    <hr class="c-hr"/>

                    <div class="row mx-0 no-gutters">
                      <div class="col-md-6 pr-md-3">
                        <b-form-group class="custom-input" label="Razon social:" label-for="f-nombre" >
                          <b-form-input id="f-bussines_name" type="text" v-model="form.user.bussines_name" size="sm" required/>
                        </b-form-group>


                      </div>

                      <div class="col-md-6">
                        <b-form-group class="custom-input" label="Rfc:" label-for="f-rfc" >
                          <b-form-input id="f-rfc" type="text" v-model="form.user.rfc" size="sm" required minlength="12" maxlength="13"/>
                        </b-form-group>

                      </div>
                    </div>

                      <div class="row mx-0 no-gutters">
                      <div class="col-md-7 col-lg-6">
                        <b-form-group class="custom-input" label="Calle:" label-for="i-calle">
                          <b-form-input id="i-calle" type="text" v-model="form.user.adddres_facturacion.street" size="sm" placeholder="Calle donde vive" required/>
                        </b-form-group>

                      </div>

                      <div class="col-md pl-md-3">
                        <b-form-group class="custom-input" label="Numero exterior:" label-for="i-num" >
                          <b-form-input id="i-num" type="text" v-model="form.user.adddres_facturacion.num_ext" size="sm" required/>
                        </b-form-group>

                      </div>

                      <div class="col-md pl-md-3">
                        <b-form-group class="custom-input" label="Numero interior:" label-for="i-num" >
                          <b-form-input id="i-num" type="text" v-model="form.user.adddres_facturacion.num_int" size="sm" />
                        </b-form-group>
                      </div>
                    </div>

                    <div class="row mx-0 no-gutters">
                      <div class="col-md-8">
                        <b-form-group class="custom-input" label="Colonia:" label-for="i-colonia" >
                          <b-form-input id="i-colonia" type="text" v-model="form.user.adddres_facturacion.neighborhood" size="sm"  placeholder="Escriba su colonia" required/>
                        </b-form-group>
                      </div>

                      <div class="col-md pl-md-3">
                        <b-form-group class="custom-input" label="Código postal:" label-for="i-cp" >
                          <b-form-input id="i-cp" type="text" v-model="form.user.adddres_facturacion.zipcode" size="sm"  placeholder="Escriba su código postal" required/>
                        </b-form-group>
                      </div>
                    </div>



                    <div class="row mx-0 no-gutters">
                        <div class="col-md-6 pr-md-3">
                        <b-form-group class="custom-input" label="Estado:" label-for="i-estado">
                            <v-select v-model="form.user.adddres_facturacion.state_id" :options="states" label="name" index="id" @change="getTownsFact"/>
                        </b-form-group>
                        </div>

                        <div class="col-md-6">
                        <b-form-group class="custom-input" label="Ciudad:" label-for="i-ciudad">
                            <v-select v-model="form.user.adddres_facturacion.town_id" :options="townsFact" label="name" index="id"/>
                        </b-form-group>
                        </div>
                    </div>



                </div>

            </div>
            <!-- Paso 2, fin  -->

            <!-- Paso 3 (pago) -->
            <div class="col-12 py-4 px-4 user-data" v-if="$route.params.step == 'pago'">
              <h6><b>Información de pago</b></h6>
              <hr class="c-hr" />

              <div class="custom-input _p">
                <label class="col-form-label pt-0">Seleccione una forma de pago:</label>
              </div>

              <div class="row mb-4 payment-options-container">
                <div class="col col-box" @click="changePaymentMe('tarjetas')">
                  <div class="box" v-bind:class="{ active: form.tipoPago == 'tarjetas' }">
                    <h6>Tarjeta de crédito o débito</h6>
                    <p class="icons">
                      <i class="fab fa-cc-visa"></i>
                      <i class="fab fa-cc-mastercard"></i>
                      <i class="fab fa-cc-amex"></i>
                    </p>
                  </div>
                </div>

                <div class="col col-box" @click="changePaymentMe('transferencia')">
                  <div class="box" v-bind:class="{ active: form.tipoPago == 'transferencia' }">
                    <h6>Deposito o transferencia</h6>
                    <p class="icons">
                      <i class="fas fa-money-check-alt"></i>
                      <i class="fas fa-money-bill"></i>

                    </p>
                  </div>
                </div>

                <!-- <div class="col col-box" @click="changePaymentMe('paypal')">
                  <div class="box" v-bind:class="{ active: form.tipoPago == 'paypal' }">
                    <h6>Pago a traves de Paypal</h6>
                    <p class="icons">
                      <i class="fab fa-paypal"></i>
                    </p>
                  </div>
                </div> -->
              </div>

              <!-- Pago 1, con tarjetas -->
              <div class="row mx-0 no-gutters" v-if="form.tipoPago == 'tarjetas'">
                <div class="col-12">
                    <label class="mt-3">Detalles de tarjeta:</label>
                    <div id="cardElement"></div>
                    <small class="form text text-muted" id="cardErrors" role="alert"></small>
                </div>
              </div>
              <!--  -->

              <!-- Pago 2, con transferencia bancaria -->
              <div class="col-12 text-center" v-if="form.tipoPago == 'transferencia'">
                <p><img :src="depositinfo.imageUrl" width="100px"></p>
                <p><strong>TITULAR:</strong> {{depositinfo.titular}}</p>
                <p><strong>CLABE INTERBANCARIA:</strong> {{depositinfo.clabe}}</p>
                <p><strong>NÚMERO DE CUENTA:</strong> {{depositinfo.numero_cuenta}}</p>
                <hr />
                <p>
                  Favor de enviarnos el comprobante de pago al siguiente correo: <br />
                  <strong>pago@maderasyferreteriasduran.online</strong>
                </p>
              </div>
              <!--  -->

              <!-- Pago 3, con paypal -->
              <div class="col-12 text-center" v-if="form.tipoPago == 'paypal'">
                <p>Depósito por medio de paypal.</p>

                <hr />
                <p>
                  Favor de enviarnos el comprobante de pago al siguiente correo: <br />
                  <strong>pago@maderasyferreteriasduran.online</strong>
                </p>
              </div>
              <!--  -->
            </div>
            <!-- Paso 3, fin -->
          </b-form>

          <div class="row mx-0 py-3 px-lg-0 no-gutters row-total">
            <div class="col-lg-6">
              <router-link class="btn btn-outline-danger btn-sm btn-action" :to="'/cart/' + form.prev" v-if="form.prev != null">Anterior</router-link>
              <router-link class="btn btn-outline-danger btn-sm btn-action" :to="'/cart/' + form.next" v-if="form.next">Siguiente</router-link>
              <!-- <button class="btn btn-danger btn-sm btn-action" v-if="form.paying && form.tipoPago == 'transferencia'" @click="createOrder()" :disabled="order_id">Confirmar pedido</button> -->
              <button class="btn btn-danger btn-sm btn-action" v-if="form.paying && form.tipoPago == 'transferencia'" @click="pagar()" :disabled="desactivar || order_id">Confirmar pedido</button>
              <button class="btn btn-danger btn-sm btn-action" v-if="form.paying && form.tipoPago == 'tarjetas'" @click="pagar()" :disabled="desactivar || order_id || form.payment_intent_id">Pagar</button>
            </div>

            <div class="col-lg-6 text-right">
              <h6><span>Subtotal: </span> ${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(subtotal) }}</h6>
              <h6 v-if="form.shippingMethod == null"><span>Envío: </span> Por definir...</h6>
              <h6 v-else-if="form.shippingMethod == 'Enviar a domicilio'">
                  <span v-if="form.user.street != null && form.user.num_ext != null && form.user.state_id != null && form.user.town_id != null && form.user.neighborhood != null && form.user.zipcode != null">
                    <span>Envío: </span> ${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(form.envio) }}
                  </span>
                  <span v-else>
                    Envío: Por definir...
                  </span>
                  
              </h6>
              <h5><span>Total: </span> ${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(total) }}</h5>
            </div>

            <div class="col-12 col-free" v-if="form.envio > 0 && form.shippingMethod == 'Enviar a domicilio'">
              <div class="box-free">
                Agrega <strong class="f-w-600"><u>${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(for_freeship) }}</u></strong> para obtener envío gratis.
              </div>
            </div>
          </div>
        </div>
      </div>

      <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">
        <div class="fa-3x" v-if="modal.icon== ''"><i class="fas fa-spinner fa-pulse"></i></div><br/>
        <div v-html="modal.msg"></div>
        <div class="col-12 text-center" style="padding-top: 20px;" v-if="modal.icon == 'success'">
          <b-button class="btn btn-success" slot="button" v-on:click.prevent="$refs.modal.close(); $router.push('/')">Regresar a Home <i class="color-white fas fa-home"></i></b-button>
        </div>
      </sweet-modal>

    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      form: {
        products: [],

        user: {
          "email": null,
          "name": null,
          "lastname": null,
          "phone": null,
          "street": null,
          "num_ext": null,
          "num_int": null,
          "neighborhood":null,
          "zipcode": null,
          "state_id": null,
          "town_id": null,
          'rfc':null,
          'bussines_name':null,
          adddres_facturacion:{
            street: null,
            num_ext: null,
            num_int: null,
            neighborhood: null,
            zipcode: null,
            state_id: null,
            town_id: null,
          },
        },

        prev: '',
        next: '',
        paying: false,

        tipoPago: '',
        subtotal: 0,
        total: 0,
        envio: 0,
        shippingMethod: null,
        factura:false,
        branchoffices_id:null,

      },

      modal:{
        msg:'',
        icon:'',
        block:false,
      },

      userLogin: false,
      states: [],
      towns: [],
      townsFact:[],
      order_id: null,
      paqueteria: 0,

      stripe: {},
      elements: {},
      cardElement: {},

      desactivar: false,
      branchofficesOpcs:[],
      depositinfo:{
        banco:null,
        titular:null,
        clabe:null,
    		numero_cuenta:null
      },
      costo_envio:0,
      coloniastecate:[
        {id:"1 de Mayo"},
        {id:"Aldrete"},
        {id:"Alfonso Garzón"},
        {id:"Ampliación Colinas del Cuchumá"},
        {id:"Ampliación Descanso"},
        {id:"Andalucía"},
        {id:"Arroyo Residencial"},
        {id:"Bella Vista"},
        {id:"Benito Juárez"},
        {id:"Braulio Maldonado"},
        {id:"Carmen Serdán"},
        {id:"Carreño"},
        {id:"Cerro Azul"},
        {id:"Chula Vista"},
        {id:"Chávez"},
        {id:"Colinas del Cuchumá"},
        {id:"Colinas del Cuchumá Norte"},
        {id:"Cuauhtémoc Este"},
        {id:"Cucapah"},
        {id:"Downey"},
        {id:"El Descanso"},
        {id:"El Dorado"},
        {id:"El Encinal"},
        {id:"El Hongo"},
        {id:"El Mirador"},
        {id:"El Pedregal"},
        {id:"El Refugio"},
        {id:"El Testerazo"},
        {id:"El Yaqui"},
        {id:"Emiliano Zapata"},
        {id:"Encanto Norte"},
        {id:"Encanto Sur"},
        {id:"Escorial"},
        {id:"Escudero"},
        {id:"Espinoza"},
        {id:"Esteban Cantú"},
        {id:"Federal"},
        {id:"Felipe Ángeles"},
        {id:"Fovissste"},
        {id:"Francisco Villa"},
        {id:"Fundadores"},
        {id:"González"},
        {id:"Guadalajara"},
        {id:"Guajardo"},
        {id:"Hacienda Tecate"},
        {id:"Infonavit Canaima"},
        {id:"Infonavit Industrial"},
        {id:"Infonavit Loma Alta"},
        {id:"Industrial"},
        {id:"Jacumen"},
        {id:"Jardines del Pedregal"},
        {id:"Jardines del Río"},
        {id:"La Bondad"},
        {id:"La Hacienda"},
        {id:"La Rumorosa"},
        {id:"La Sierra"},
        {id:"La Viñita"},
        {id:"Laderas de Tecate"},
        {id:"Las Huertas"},
        {id:"Las Torres"},
        {id:"Libertad"},
        {id:"Loma Alta"},
        {id:"Loma Alta II"},
        {id:"Lomas de Santa Anita"},
        {id:"Lomas de Santa Fe"},
        {id:"Lomitas del Cuchumá"},
        {id:"Los Compadres"},
        {id:"Luis Donaldo Colosio"},
        {id:"Luis Echeverría Álvarez"},
        {id:"Maclovio Herrera"},
        {id:"Miguel Alemán"},
        {id:"Militar"},
        {id:"Moctezuma"},
        {id:"Moderna"},
        {id:"Morelos"},
        {id:"Neji"},
        {id:"Nueva Hindú"},
        {id:"Palmillas"},
        {id:"Paraíso"},
        {id:"Paseo del Águila Rancho Eseorial"},
        {id:"Paso del Águila"},
        {id:"Pliego"},
        {id:"Popular Emiliano Zapata"},
        {id:"Prohogar"},
        {id:"Ranca Gandul"},
        {id:"Rancho Santa Fe"},
        {id:"Rancho Viejo"},
        {id:"Residencial San Jorge"},
        {id:"Rincón Tecate"},
        {id:"Rincón Tecate 2ª Sección"},
        {id:"Rincón Tecate 3ª Etapa"},
        {id:"Romero"},
        {id:"San Fernando"},
        {id:"San Francisco"},
        {id:"San Jorge"},
        {id:"San José"},
        {id:"Sandoval"},
        {id:"Santa Anita"},
        {id:"Santa Verónica"},
        {id:"Solidaridad"},
        {id:"Tanama"},
        {id:"Tecate"},
        {id:"Tecate Centro"},
        {id:"Tepeyac"},
        {id:"Terrazas del Río"},
        {id:"Trece Ayuntamiento"},
        {id:"Valencia"},
        {id:"Valle de las Palmas"},
        {id:"Valle Verde"},
        {id:"Villa Artesanal Milton Castellanos"},
        {id:"Zorrilla"},
      ],
      coloniasrosarito:[
        {id:"17 de Agosto"},
        {id:"Ampliación Benito Juárez"},
        {id:"Ampliación Ejido Plan Libertador"},
        {id:"Anexa Obrera"},
        {id:"Aztlán"},
        {id:"Baja del Mar"},
        {id:"Basso"},
        {id:"Benito Juárez"},
        {id:"Caminos Alegres"},
        {id:"Campestre La Mina de San Antonio"},
        {id:"Campos Reynoso"},
        {id:"Cañón Altamira"},
        {id:"Cantamar"},
        {id:"Cantiles Dorados"},
        {id:"Castillos del Mar"},
        {id:"Catalina del Mar"},
        {id:"Colina de Aragón"},
        {id:"Colinas de Mazatlán"},
        {id:"Colinas de Rosarito 1ª Sección"},
        {id:"Constitución"},
        {id:"Crosthwhite"},
        {id:"Cuenca Lechera"},
        {id:"Cumbres de Rosarito"},
        {id:"Echeverría"},
        {id:"Eduardo Crosthwhite"},
        {id:"Ejido Mazatlán"},
        {id:"El Mañana"},
        {id:"El Oasis"},
        {id:"Hacienda Floresta"},
        {id:"Hacienda San Fernando"},
        {id:"Huacatay"},
        {id:"Independencia"},
        {id:"Jorge Días Serrano"},
        {id:"La Barca"},
        {id:"La Capilla"},
        {id:"La Cascada"},
        {id:"La Cuesta"},
        {id:"La Mina"},
        {id:"La Paloma"},
        {id:"Las 2 Palomas"},
        {id:"Las Gaviotas"},
        {id:"Lepro"},
        {id:"Lienzo Charro"},
        {id:"Lomas Altas II"},
        {id:"Lomas de Desierto"},
        {id:"Lomas de Montecarlo"},
        {id:"Lomas de Rosarito"},
        {id:"Lomas Tacalli"},
        {id:"López Gutierrez"},
        {id:"Los Ángeles"},
        {id:"Los Arroyos"},
        {id:"Lucio Blanco"},
        {id:"Machado Norte"},
        {id:"Machado Sur"},
        {id:"Magisterial"},
        {id:"Marbella"},
        {id:"Mar de Calafia"},
        {id:"Mar de Popotla"},
        {id:"Marisol"},
        {id:"Mexicali"},
        {id:"Miramar"},
        {id:"Misión del Mar II"},
        {id:"Montecarlo 2"},
        {id:"Morelos"},
        {id:"Nuevo Municipio"},
        {id:"Obrera"},
        {id:"Pemex"},
        {id:"Pescador"},
        {id:"Plan Libertador"},
        {id:"Playa Encantada"},
        {id:"Playa Hermosa"},
        {id:"Playas de Santander"},
        {id:"Popotla"},
        {id:"Primo Tapia"},
        {id:"Primo Tapia"},
        {id:"Puerto Nuevo"},
        {id:"Quinta del Mar"},
        {id:"Rancho Chula Vista"},
        {id:"Rancho del Mar"},
        {id:"Rancho El Mirador"},
        {id:"Rancho las Chollas"},
        {id:"Real de Mar"},
        {id:"Real del Rosarito"},
        {id:"Real del Rosarito II"},
        {id:"Reforma"},
        {id:"Renes"},
        {id:"Reserva San Fernando"},
        {id:"Rica Mar"},
        {id:"Rosarito"},
        {id:"Rosarito Centro"},
        {id:"Rosarito Este"},
        {id:"Salinas de Gortari"},
        {id:"Santa Anita del Mar"},
        {id:"Santa Isabel del Mar"},
        {id:"Santa Lucia"},
        {id:"Santa Lucia 2ª Sección"},
        {id:"Santa Mónica"},
        {id:"Terrazas del Mar"},
        {id:"Terrazas del Pacífico"},
        {id:"Tijuana"},
        {id:"Venustiano Carranza"},
        {id:"Veracruz"},
        {id:"Villa Bonita"},
        {id:"Villa Corona del Mar"},
        {id:"Villa Floresta"},
        {id:"Villa Italiana"},
        {id:"Villa Mar"},
        {id:"Villas de Rosarito"},
        {id:"Villas San Ángel"},
        {id:"Vista al Mar"},
        {id:"Vista Hermosa"}
      ],
      coloniastijuana:[
        {id:'Centro'},
        {id:'Cerro colorado'},
        {id:'La Mesa'},
        {id:'La presa ALR'},
        {id:'La Presa este'},
        {id:'Otay centenario'},
        {id:'Playas'},
        {id:'San Antonio de los Buenos'},
        {id:'Sánchez Taboada'},
        {id:'Otra'}
      ],
      for_freeship:0,
      checkterms:false,
    }
  },

  computed: {
    subtotal() {
     var subtotal = this.form.products.reduce(function (subtotal, item) {
        return subtotal + (item.price * item.quantity)
      },0);

      return this.form.subtotal = subtotal;
    },
    /*582 = Ensenada
    1011 = Mexicali
    1224 = Playas de Rosarito
    2009 = Tecate
    2141 = Tijuana
    */
    total() {
      var subtotal = this.form.products.reduce(function (sum, item) {
        return sum +  (item.price * item.quantity)
      },0);

        if(this.form.shippingMethod == 'Recoger en tienda'){

            this.form.envio = 0;
        }

        if(this.form.shippingMethod == 'Enviar a domicilio'){
          //Tecate
          if(this.form.user.town_id == 2009) {
              if(this.form.user.neighborhood == 'Carmen Serdán' || this.form.user.neighborhood == 'Chula Vista' || this.form.user.neighborhood == 'El Dorado' || this.form.user.neighborhood == 'El Encinal' || this.form.user.neighborhood == 'El Testerazo' || this.form.user.neighborhood == 'Felipe Ángeles' || this.form.user.neighborhood == 'Guadalajara' || this.form.user.neighborhood == 'Hacienda Tecate' || this.form.user.neighborhood == 'Jacumen' || this.form.user.neighborhood == 'Loma Tova' || this.form.user.neighborhood == 'Los Compadres' || this.form.user.neighborhood == 'Neji' || this.form.user.neighborhood == 'Rancho Viejo' || this.form.user.neighborhood == 'San Francisco' || this.form.user.neighborhood == 'San Pablo' || this.form.user.neighborhood == 'Santa Verónica' || this.form.user.neighborhood == 'Tanama' || this.form.user.neighborhood == 'Villa Artesanal Milton Castellanos' || this.form.user.neighborhood == 'Paso del Águila' || this.form.user.neighborhood == 'El Hongo' || this.form.user.neighborhood == 'Cerro Azul' || this.form.user.neighborhood == 'Nueva Hindú' || this.form.user.neighborhood == 'Luis Echeverría Álvarez' || this.form.user.neighborhood == 'Valle de las Palmas' || this.form.user.neighborhood == 'La Rumorosa'){
                if(this.form.subtotal >= 7000){
                      this.form.envio = 0;
                  }
                  else{
                      this.form.envio = 500;
                      this.for_freeship = 7000 - this.form.subtotal;
                  }
              }
              else if(this.form.user.neighborhood == '1 de Mayo' || this.form.user.neighborhood == 'Aldrete' || this.form.user.neighborhood == 'Alfonso Garzón' || this.form.user.neighborhood == 'Ampliación Colinas del Cuchumá' || this.form.user.neighborhood == 'Ampliación Descanso' || this.form.user.neighborhood == 'Andalucía' || this.form.user.neighborhood == 'Arroyo Residencial' || this.form.user.neighborhood == 'Bella Vista' || this.form.user.neighborhood == 'Benito Juárez' || this.form.user.neighborhood == 'Braulio Maldonado' || this.form.user.neighborhood == 'Carreño' || this.form.user.neighborhood == 'Cerro Azul' || this.form.user.neighborhood == 'Chávez' || this.form.user.neighborhood == 'Colinas del Cuchumá' || this.form.user.neighborhood == 'Colinas del Cuchumá Norte' || this.form.user.neighborhood == 'Cuauhtémoc Este' || this.form.user.neighborhood == 'Cucapah' || this.form.user.neighborhood == 'Downey' || this.form.user.neighborhood == 'El Descanso' || this.form.user.neighborhood == 'El Mirador' || this.form.user.neighborhood == 'El Pedregal' || this.form.user.neighborhood == 'El Refugio' || this.form.user.neighborhood == 'El Yaqui' || this.form.user.neighborhood == 'Emiliano Zapata' || this.form.user.neighborhood == 'Encanto Norte' || this.form.user.neighborhood == 'Encanto Sur' || this.form.user.neighborhood == 'Escorial' || this.form.user.neighborhood == 'Escudero' || this.form.user.neighborhood == 'Espinoza' || this.form.user.neighborhood == 'Esteban Cantú' || this.form.user.neighborhood == 'Federal' || this.form.user.neighborhood == 'Fovissste' || this.form.user.neighborhood == 'Francisco Villa' || this.form.user.neighborhood == 'Fundadores' || this.form.user.neighborhood == 'González' || this.form.user.neighborhood == 'Guajardo' || this.form.user.neighborhood == 'Industrial' || this.form.user.neighborhood == 'Infonavit Canaima' || this.form.user.neighborhood == 'Infonavit Industrial' || this.form.user.neighborhood == 'Infonavit Loma Alta' || this.form.user.neighborhood == 'Jardines del Pedregal' || this.form.user.neighborhood == 'Jardines del Río' || this.form.user.neighborhood == 'Lázaro Cárdenas' || this.form.user.neighborhood == 'La Bondad' || this.form.user.neighborhood == 'La Hacienda' || this.form.user.neighborhood == 'La Sierra' || this.form.user.neighborhood == 'La Viñita' || this.form.user.neighborhood == 'Laderas de Tecate' || this.form.user.neighborhood == 'Las Huertas' || this.form.user.neighborhood == 'Las Torres' || this.form.user.neighborhood == 'Libertad' || this.form.user.neighborhood == 'Loma Alta' || this.form.user.neighborhood == 'Loma Alta II' || this.form.user.neighborhood == 'Lomas de Santa Anita' || this.form.user.neighborhood == 'Lomas de Santa Fe' || this.form.user.neighborhood == 'Lomitas del Cuchumá' || this.form.user.neighborhood == 'Luis Donaldo Colosio' || this.form.user.neighborhood == 'Maclovio Herrera' || this.form.user.neighborhood == 'Miguel Alemán' || this.form.user.neighborhood == 'Militar' || this.form.user.neighborhood == 'Moctezuma' || this.form.user.neighborhood == 'Moderna' || this.form.user.neighborhood == 'Morelos' || this.form.user.neighborhood == 'Palmillas' || this.form.user.neighborhood == 'Paraíso' || this.form.user.neighborhood == 'Paseo del Águila Rancho Eseorial' || this.form.user.neighborhood == 'Pliego' || this.form.user.neighborhood == 'Popular Emiliano Zapata' || this.form.user.neighborhood == 'Prohogar' || this.form.user.neighborhood == 'Rancha Gandul' || this.form.user.neighborhood == 'Rancho Santa Fe' || this.form.user.neighborhood == 'Residencial San Jorge' || this.form.user.neighborhood == 'Rincón Tecate' || this.form.user.neighborhood == 'Rincón Tecate 2ª Sección' || this.form.user.neighborhood == 'Rincón Tecate 3ª Etapa' || this.form.user.neighborhood == 'Romero' || this.form.user.neighborhood == 'San Fernando' || this.form.user.neighborhood == 'San Jorge' || this.form.user.neighborhood == 'San José' || this.form.user.neighborhood == 'Sandoval' || this.form.user.neighborhood == 'Santa Anita' || this.form.user.neighborhood == 'Solidaridad' || this.form.user.neighborhood == 'Tecate' || this.form.user.neighborhood == 'Tecate Centro' || this.form.user.neighborhood == 'Tepeyac' || this.form.user.neighborhood == 'Terrazas del Río' || this.form.user.neighborhood == 'Trece Ayuntamiento' || this.form.user.neighborhood == 'Valencia' || this.form.user.neighborhood == 'Valle Verde' || this.form.user.neighborhood == 'Zorrilla' ){

                  if(this.form.subtotal >= 700){
                      this.form.envio = 0;
                  }
                  else{
                      this.form.envio = 300;
                      this.for_freeship = 700 - this.form.subtotal;
                  }
              }
          }
          //Playas de rosarito
          else if(this.form.user.town_id == 1224) {
              if(this.form.user.neighborhood == '17 de Agosto' || this.form.user.neighborhood == 'Ampliación Benito Juárez' || this.form.user.neighborhood == 'Anexa Obrera' || this.form.user.neighborhood == 'Aztlán' || this.form.user.neighborhood == 'Baja del Mar' || this.form.user.neighborhood == 'Basso' || this.form.user.neighborhood == 'Benito Juárez' || this.form.user.neighborhood == 'Camino Alegre' || this.form.user.neighborhood == 'Campestre La Mina de San Antonio' || this.form.user.neighborhood == 'Campos Reynoso' || this.form.user.neighborhood == 'Cañón Altamira' || this.form.user.neighborhood == 'Cantamar' || this.form.user.neighborhood == 'Cantiles Dorados' || this.form.user.neighborhood == 'Castillos del Mar' || this.form.user.neighborhood == 'Catalina del Mar' || this.form.user.neighborhood == 'Colinas de Aragón' || this.form.user.neighborhood == 'Colinas de Mazatlán' || this.form.user.neighborhood == 'Colinas de Rosarito 1ª Sección' || this.form.user.neighborhood == 'Constitución' || this.form.user.neighborhood == 'Crosthwhite' || this.form.user.neighborhood == 'Cuenca Lechera' || this.form.user.neighborhood == 'Cumbres de Rosarito' || this.form.user.neighborhood == 'Echeverría' || this.form.user.neighborhood == 'Eduardo Crosthwhite' || this.form.user.neighborhood == 'Ejido Mazatlán' || this.form.user.neighborhood == 'El Mañana' || this.form.user.neighborhood == 'El Oasis' || this.form.user.neighborhood == 'Hacienda Floresta' || this.form.user.neighborhood == 'Hacienda San Fernando' || this.form.user.neighborhood == 'Huacatay' || this.form.user.neighborhood == 'Independencia' || this.form.user.neighborhood == 'Jorge Días Serrano' || this.form.user.neighborhood == 'La Barca' || this.form.user.neighborhood == 'La Capilla' || this.form.user.neighborhood == 'La Cascada' || this.form.user.neighborhood == 'La Cuesta' || this.form.user.neighborhood == 'La Mina' || this.form.user.neighborhood == 'La Paloma' || this.form.user.neighborhood == 'Las 2 Palomas' || this.form.user.neighborhood == 'Las Gaviotas' || this.form.user.neighborhood == 'Lepro' || this.form.user.neighborhood == 'Lienzo Charro' || this.form.user.neighborhood == 'Lomas Altas II' || this.form.user.neighborhood == 'Lomas de Desierto' || this.form.user.neighborhood == 'Lomas de Montecarlo' || this.form.user.neighborhood == 'Lomas de Rosarito' || this.form.user.neighborhood == 'Lomas Tacalli' || this.form.user.neighborhood == 'López Gutierrez' || this.form.user.neighborhood == 'Los Ángeles' || this.form.user.neighborhood == 'Los Arroyos' || this.form.user.neighborhood == 'Lucio Blanco' || this.form.user.neighborhood == 'Machado Norte' || this.form.user.neighborhood == 'Machado Sur' || this.form.user.neighborhood == 'Magisterial' || this.form.user.neighborhood == 'Marbella' || this.form.user.neighborhood == 'Mar de Calafia' || this.form.user.neighborhood == 'Mar de Popotla' || this.form.user.neighborhood == 'Marisol' || this.form.user.neighborhood == 'Mexicali' || this.form.user.neighborhood == 'Miramar' || this.form.user.neighborhood == 'Misión del Mar II' || this.form.user.neighborhood == 'Montecarlo 2' || this.form.user.neighborhood == 'Morelos' || this.form.user.neighborhood == 'Nuevo Municipio' || this.form.user.neighborhood == 'Obrera' || this.form.user.neighborhood == 'Pemex' || this.form.user.neighborhood == 'Pescador' || this.form.user.neighborhood == 'Plan Libertador' || this.form.user.neighborhood == 'Playa Encantada' || this.form.user.neighborhood == 'Playa Hermosa' || this.form.user.neighborhood == 'Playas de Santander' || this.form.user.neighborhood == 'Popotla' || this.form.user.neighborhood == 'Primo Tapia' || this.form.user.neighborhood == 'Puerto Nuevo' || this.form.user.neighborhood == 'Quinta del Mar' || this.form.user.neighborhood == 'Rancho Chula Vista' || this.form.user.neighborhood == 'Rancho del Mar' || this.form.user.neighborhood == 'Rancho El Mirador' || this.form.user.neighborhood == 'Rancho las Chollas' || this.form.user.neighborhood == 'Real de Mar' || this.form.user.neighborhood == 'Real del Rosarito' || this.form.user.neighborhood == 'Real de Rosarito II' || this.form.user.neighborhood == 'Reforma' || this.form.user.neighborhood == 'Renes' || this.form.user.neighborhood == 'Reserva San Fernando' || this.form.user.neighborhood == 'Rica Mar' || this.form.user.neighborhood == 'Rosarito' || this.form.user.neighborhood == 'Rosarito Centro' || this.form.user.neighborhood == 'Rosarito Este' || this.form.user.neighborhood == 'Salinas de Gortari' || this.form.user.neighborhood == 'Santa Anita del Mar' || this.form.user.neighborhood == 'Santa Isabel del Mar' || this.form.user.neighborhood == 'Santa Lucia' || this.form.user.neighborhood == 'Santa Lucia 2ª Sección' || this.form.user.neighborhood == 'Santa Mónica' || this.form.user.neighborhood == 'Terrazas del Mar' || this.form.user.neighborhood == 'Terrazas del Pacífico' || this.form.user.neighborhood == 'Tijuana' || this.form.user.neighborhood == 'Venustiano Carranza' || this.form.user.neighborhood == 'Veracruz' || this.form.user.neighborhood == 'Villa Bonita' || this.form.user.neighborhood == 'Villa Corona del Mar' || this.form.user.neighborhood == 'Villa Floresta' || this.form.user.neighborhood == 'Villa Italiana' || this.form.user.neighborhood == 'Villa Mar' || this.form.user.neighborhood == 'Villas de Rosarito' || this.form.user.neighborhood == 'Villas San Ángel' || this.form.user.neighborhood == 'Vista al Mar' || this.form.user.neighborhood == 'Vista Hermosa'){
                if(this.form.subtotal >= 1500){
                      this.form.envio = 0;
                  }
                  else{
                      this.form.envio = 300;
                      this.for_freeship = 1500 - this.form.subtotal;
                  }
              }
              else if(this.form.user.neighborhood == 'Ampliación Ejido Plan Libertador' || this.form.user.neighborhood == 'Primo Tapia' || this.form.user.neighborhood == 'Colonia Morelos'){

                  if(this.form.subtotal >= 5000){
                      this.form.envio = 0;
                  }
                  else{
                      this.form.envio = 500;
                      this.for_freeship = 5000 - this.form.subtotal;
                  }
              }
          }
          //Tijuana
          else if(this.form.user.town_id == 2141) {
              if(this.form.user.neighborhood == 'Centro' || this.form.user.neighborhood == 'Cerro colorado' || this.form.user.neighborhood == 'La Mesa' || this.form.user.neighborhood == 'La presa ALR' || this.form.user.neighborhood == 'La Presa este' || this.form.user.neighborhood == 'Otay centenario' || this.form.user.neighborhood == 'Playas' || this.form.user.neighborhood == 'San Antonio de los Buenos' || this.form.user.neighborhood == 'Sánchez Taboada'){
                  if(this.form.subtotal >= 1500){
                      this.form.envio = 0;
                  }
                  else{
                      this.form.envio = 300;
                      this.for_freeship = 1500 - this.form.subtotal;
                  }
              }
              else {

                  if(this.form.subtotal >= 5000){
                      this.form.envio = 0;
                  }
                  else{
                      this.form.envio = 500;
                      this.for_freeship = 5000 - this.form.subtotal;
                  }
              }
          }
          //Ensenada
          else if(this.form.user.town_id == 582) {
              if(this.form.subtotal >= 30000){
                      this.form.envio = 0;
                  }
                  else{
                      this.form.envio = 300;
                      this.for_freeship = 30000 - this.form.subtotal;
                  }
          }
           //Mexicali
          else if(this.form.user.town_id == 1011) {
            if(this.form.subtotal >= 50000){
                      this.form.envio = 0;
                  }
                  else{
                      this.form.envio = 300;
                      this.for_freeship = 50000 - this.form.subtotal;
                  }
          }
          else{
            this.form.envio = 300;
          }

        }

      var grandTotal  = parseFloat(subtotal) + parseFloat(this.form.envio);
      return this.form.total = grandTotal;
    }
  },

  methods: {
    changePaymentMe(tipo){
      this.form.tipoPago = tipo;
      if(tipo == "tarjetas"){

        if(this.form.total < 10){
          this.form.tipoPago = '';
            this.modal.block = false;
            this.modal.icon = 'warning';
            this.modal.msg = 'Para pagar con tarjeta, el total debe ser mayor a $10.00';
            this.$refs.modal.open();
            return;
        }
        else{

           setTimeout(this.loadStripe, 50);
        }
      }
    },

    pagar(){
      if(this.form.tipoPago == "transferencia"){
        this.desactivar = true;
        this.createOrder();
      }

      if(this.form.tipoPago == "tarjetas"){
          this.desactivar = true;
          this.payStripe();

      }
    },

    getSteps(){
      var step = this.$route.params.step;
      this.form.paying = false;

      if(step == 'pago'){ // Paso 3
        if(this.checkterms == false){
            this.form.prev = '';
            this.form.next = 'pago';
            this.$router.push('/cart/envio');

            this.modal.block = false;
            this.modal.icon = 'warning';
            this.modal.msg = 'Debes aceptar los Terminos y Condiciones y Aviso de privacidad';
            this.$refs.modal.open();
            return;
        }
        if(this.form.shippingMethod == 'Enviar a domicilio'){
            //this.getDistance();
        }

        if(this.form.user.name == null){
          this.form.prev = '';
            this.form.next = 'pago';
            this.$router.push('/cart/envio');

            this.modal.block = false;
            this.modal.icon = 'warning';
            this.modal.msg = 'El campo "Nombre" es obligatorio';
            this.$refs.modal.open();
            return;
        }
        if(this.form.user.lastname == null){
          this.form.prev = '';
            this.form.next = 'pago';
            this.$router.push('/cart/envio');

           this.modal.block = false;
            this.modal.icon = 'warning';
            this.modal.msg = 'El campo "Apellidos" es obligatorio';
            this.$refs.modal.open();
            return;
        }
        if(this.form.user.email == null){
          this.form.prev = '';
            this.form.next = 'pago';
            this.$router.push('/cart/envio');

           this.modal.block = false;
            this.modal.icon = 'warning';
            this.modal.msg = 'El campo "Email" es obligatorio';
            this.$refs.modal.open();
            return;
        }
        if(this.form.user.phone == null){
          this.form.prev = '';
            this.form.next = 'pago';
            this.$router.push('/cart/envio');

           this.modal.block = false;
            this.modal.icon = 'warning';
            this.modal.msg = 'El campo "Teléfono" es obligatorio';
            this.$refs.modal.open();
            return;
        }
        if(this.form.shippingMethod == 'Enviar a domicilio'){

            if(this.form.user.street == null){
              this.form.prev = '';
                this.form.next = 'pago';
                this.$router.push('/cart/envio');

              this.modal.block = false;
                this.modal.icon = 'warning';
                this.modal.msg = 'El campo "Calle" es obligatorio';
                this.$refs.modal.open();
                return;
            }
            if(this.form.user.num_ext == null){
              this.form.prev = '';
                this.form.next = 'pago';
                this.$router.push('/cart/envio');

              this.modal.block = false;
                this.modal.icon = 'warning';
                this.modal.msg = 'El campo "Numero exterior" es obligatorio';
                this.$refs.modal.open();
                return;
            }
            if(this.form.user.neighborhood == null){
                this.form.prev = '';
                this.form.next = 'pago';
                this.$router.push('/cart/envio');

              this.modal.block = false;
                this.modal.icon = 'warning';
                this.modal.msg = 'El campo "Colonia" es obligatorio';
                this.$refs.modal.open();
                return;
            }
            if(this.form.user.zipcode == null){
                this.form.prev = '';
                this.form.next = 'pago';
                this.$router.push('/cart/envio');

              this.modal.block = false;
                this.modal.icon = 'warning';
                this.modal.msg = 'El campo "Código postal" es obligatorio';
                this.$refs.modal.open();
                return;
            }
            if(this.form.user.state_id == null){
                this.form.prev = '';
                this.form.next = 'pago';
                this.$router.push('/cart/envio');

              this.modal.block = false;
                this.modal.icon = 'warning';
                this.modal.msg = 'El campo "Estado" es obligatorio';
                this.$refs.modal.open();
                return;


            }
            if(this.form.user.town_id == null){
              this.form.prev = '';
                this.form.next = 'pago';
                this.$router.push('/cart/envio');

               this.modal.block = false;
                this.modal.icon = 'warning';
                this.modal.msg = 'El campo "Ciudad" es obligatorio';
                this.$refs.modal.open();
                return;
            }
        }
        else if(this.form.shippingMethod == 'Recoger en tienda'){
            if(this.form.branchoffices_id == null){
              this.form.prev = '';
                this.form.next = 'pago';
                this.$router.push('/cart/envio');

               this.modal.block = false;
                this.modal.icon = 'warning';
                this.modal.msg = 'Debes seleccionar una Sucursal para recoger';
                this.$refs.modal.open();
                return;
            }
        }
        else{
          this.form.prev = '';
            this.form.next = 'pago';
            this.$router.push('/cart/envio');

           this.modal.block = false;
            this.modal.icon = 'warning';
            this.modal.msg = 'Debes de seleccionar un Tipo de entrega';
            this.$refs.modal.open();
            return;
        }

        this.form.prev = 'envio';
        this.form.next = null;
        this.form.paying = true;
      }
      else if(step == 'envio'){ // Paso 2
        this.form.prev = '';
        this.form.next = 'pago';
      }
      else{ // Paso 1
        this.form.prev = null;

        if(this.form.products.length){
          this.form.next = 'envio';
        }
      }
    },

    getStates(){
      axios.get(tools.url('/api/states')).then((response)=>{
        //this.states = response.data;
        this.states.push(response.data[1]);
      }).catch((error)=>{
         console.log(error);
      });
    },

    getTowns(){
      if(this.form.user.state_id){
        axios.get(tools.url('/api/towns/' + this.form.user.state_id)).then((response)=>{
          this.towns = response.data;
        }).catch((error)=>{
          console.log(error);
        });
      }
    },
    getTownsFact(){
      if(this.form.user.adddres_facturacion.state_id){
        axios.get(tools.url('/api/towns/' + this.form.user.adddres_facturacion.state_id)).then((response)=>{
          this.townsFact = response.data;
        }).catch((error)=>{
          console.log(error);
        });
      }
    },

    getInfo(){
      this.form.user = {
        //Datos personales
        id: this.$root.user.id,
        name: this.$root.user.name,
        lastname: this.$root.user.lastname,
        email: this.$root.user.email,
        phone: this.$root.user.phone,
        street: this.$root.user.address.street,
        num_ext: this.$root.user.address.num_ext,
        num_int: this.$root.user.address.num_int,
        neighborhood: this.$root.user.address.neighborhood,
        zipcode: this.$root.user.address.zipcode,
        state_id: this.$root.user.address.state_id,
        town_id: this.$root.user.address.town_id,
        adddres_facturacion:{
          street: null,
          num_ext: null,
          num_int: null,
          neighborhood: null,
          zipcode: null,
          state_id: null,
          town_id: null,
        }
      };

      this.getTowns();
    },

    getCart: function(){
      var storage = localStorage.getItem('cart');
      if(storage != null){
        var products = JSON.parse(storage);
        axios.post(tools.url('/api/cart'),{ products:products }).then((response)=>{
          this.form.products = response.data.cart;
          this.$root.cartCount = this.form.products.length;

          this.costo_envio = response.data.envio;
          this.getSteps();

        }).catch((error)=>{
          console.log(error);
          this.getSteps();
          this.updateCart();
        });
      }
    },

    getDistance: function(){
        axios.post(tools.url('/api/distance'),{ user:this.form.user }).then((response)=>{
            this.form.envio = response.data.price;
            this.paqueteria = response.data.price;
        }).catch((error)=>{
            console.log(error);
        });
    },

    removeCart: function(index) {
        this.$delete(this.form.products, index)
        this.updateCart();
    },

    updateCart(){
        var cart = [];
        this.form.products.forEach(function(val, index, array){
          var info = { id:val.id, quantity: val.quantity, modelo: val.modelo, color: val.color };
          cart.push(info);
        });
        localStorage.setItem("cart",JSON.stringify(cart));
        this.$root.cartCount = cart.length;
    },

    createOrder: function(){
        this.modal.block = true;
        this.modal.icon = '';
        this.modal.msg = 'Procesando, por favor espere...';
        this.$refs.modal.open();

        axios.post(tools.url('/api/order/store'),{ order:this.form, products:this.form.products, user:this.form.user, userLogin:this.$root.logged }).then((response)=>{
            if(response.data.type === "success"){
                this.order_id = response.data.order_id;
                localStorage.removeItem('cart');
                this.$root.cartCount = 0;
                //mensaje
                this.modal.icon = "success";
                this.modal.msg = "TU PEDIDO HA SIDO EXITOSO!<br/> Número de pedido: "+response.data.order_id+". Por favor de enviar su comprobante de pago";
                this.modal.block = true;
                this.desactivar = false;

            }else{
              this.desactivar = false;
                this.$refs.modal.close();
                alert(response.data.error);
            }
        }).catch((error)=>{
            console.log(error);
            this.desactivar = false;
            this.modal.icon="error";
            this.modal.msg = "Fallo al realizar el pedido., Verifique su internet y recargue la página";
            this.modal.block = false;

        });

    },

    loadStripe(){
      //sandbox key
      //this.stripe = Stripe('pk_test_51NYY2LK3Xorgof5gSJGs4UqmEVxHttr2loI4lDjJBtwAf6ZWL3F34eZo3wIwZ0UrjV3k9rQy4erb1ANMFAjYcnzW009O0RKDa0');
      this.stripe = Stripe('pk_live_51NYY2LK3Xorgof5gTnZVcs35XBYGAlbiHCGtk3h7LBcJ0K8RDiEWyYTutQKmoubaM7zkiOblsPZu1X1hai4PYLyb001z12kVmC');
      this.elements = this.stripe.elements({locale: 'es'});
      this.cardElement = this.elements.create('card', {hidePostalCode: true});

      this.cardElement.mount("#cardElement");
      this.cardElement.addEventListener('change', ({ error }) => {
          const displayError = document.getElementById('cardErrors');
          if (error) {
            displayError.textContent = error.message;
          } else {
            displayError.textContent = '';
          }
      });
    },

    payStripe(){
      
      this.modal.block = true;
      this.modal.icon = '';
      this.modal.msg = 'Validando el metodo de pago. por favor espere...';
      this.$refs.modal.open();

      this.stripe.createPaymentMethod({
          type: 'card',
          card: this.cardElement,
          billing_details: { name: this.form.user.name+' '+this.form.user.lastname, email: this.form.user.email }
        }).then((result)=>{
          if (result.error) {
            alert('Ocurrió un error con su tarjeta');
            this.desactivar = false;
          } else {
            const data  = { payment_method_id: result.paymentMethod.id, total: this.form.total, name: this.form.name, email: this.form.email };
            axios.post(tools.url('/api/stripe/Installments'),data).then((response)=>{
                this.form.payment_intent_id = response.data.intent_id;
                this.pagarStripe();
              });
          }
      });
    },

    pagarStripe: function(){
      this.modal.block = true;
      this.modal.icon = '';
      this.modal.msg = 'Generando su pedido por favor espere...';

      axios.post(tools.url('/api/stripe/pay'),{  order:this.form, products:this.form.products, user:this.form.user, userLogin:this.$root.logged }).then((response)=>{
          if(response.data.type === "success"){
            this.order_id = response.data.order_id;
            localStorage.removeItem('cart');
            this.$root.cartCount = 0;
            //mensaje

            this.modal.icon = "success";
            this.modal.msg = "TU PEDIDO HA SIDO EXITOSO!<br/> Número de pedido: "+response.data.order_id+".";
            this.modal.block = false;
            this.desactivar = false;

          }else{
            this.modal.icon = "error";
            this.modal.msg = response.data.message;
            this.modal.block = false;
            this.desactivar = false;
          }
      }).catch((error)=>{
        this.$refs.modal.close();
        alert("ERROR: No se pudo realizar el pedido.");
        this.desactivar = false;
      });
    },
    getBranchofficeOpcs: function(){
      axios.get(tools.url('/api/branchoffices')).then((response)=>{
        this.branchofficesOpcs = response.data;

      }).catch((error)=>{

      })
    },
    getDepositinfo(){
      axios.get(tools.url('/api/informaciondeposito')).then((response)=>{
        this.depositinfo = response.data;
      }).catch((error)=>{
         console.log(error);
      });
    },
    logout(){
        axios.post(tools.url("/logout")).then((response)=>{
            this.$parent.user = {};
            this.$parent.logged = false;
            this.$router.push('/login');
        }).catch(()=>{});
    },
    checkStock(indx){
        if(this.form.products[indx]['quantity'] == 0){
          this.form.products[indx]['quantity'] = 1;
        }
        else{
          if(this.form.products[indx]['quantity'] > this.form.products[indx]['stock']){
              this.form.products[indx]['quantity'] = this.form.products[indx]['stock'];
              this.modal.msg = 'El producto <b>'+this.form.products[indx]['name']+'</b><br> No cuenta con el suficiente stock';
              this.modal.icon = 'warning';
              this.$refs.modal.open();
          }
        }
    }
  },

  beforeMount(){
    this.getDepositinfo();
    this.getBranchofficeOpcs();
    this.getSteps();
    this.getStates();
    this.getCart();

    if(this.$root.logged){
      this.getInfo();
    }


  },

  watch: {
    '$route.params.step': function () {
      this.getSteps();
    },

    "$root.logged": function(v) {
      if(v == true){
        this.getInfo();
      }
    },
  }
}
</script>

<style>
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
